import React from 'react'
import layoutStyles from '../../containers/AppLayout/styles.module.less'
import { MessageCenter } from '../MessageCenter'

const PermissionDenied = () => (
  <div className={`permission-denied ${layoutStyles.offsetBar}`}>
    <MessageCenter errorMessages={['Sorry, additional permissions are required.']} />
  </div>
)

export default PermissionDenied
